import React from 'react'
import PropTypes from 'prop-types'

import { t } from 'src/lib/i18n-react'

import ActivityWrapupSkeleton from './ActivityWrapupSkeleton'
import WrapupCardRateActivity from './subcomponents/WrapupCardRateActivity/WrapupCardRateActivity'
import WrapupCardVocabulary from './subcomponents/WrapupCardVocabulary/WrapupCardVocabulary'

const ActivityWrapupMedia = ({
  activityType,
  vocabularyGroups,
  onActivityRated,
  ...rest
}) => {
  return (
    <ActivityWrapupSkeleton
      activityType={activityType}
      titleSection={t('You finished')}
      ratingSection={
        <WrapupCardRateActivity
          activityType={activityType}
          onActivityRated={onActivityRated}
        />
      }
      vocabularySection={
        <WrapupCardVocabulary vocabularyGroups={vocabularyGroups} />
      }
      {...rest}
    />
  )
}

ActivityWrapupMedia.propTypes = {
  activityType: PropTypes.oneOf(['reading', 'video', 'audio']).isRequired,
  vocabularyGroups: PropTypes.arrayOf(PropTypes.object),
  onActivityRated: PropTypes.func,
}

export default ActivityWrapupMedia
